import { InfoBox, InfoBoxContainer, InfoBoxProps, TaskPanel } from '@easylife365/react';
import type { ChooseCertificateActionProps } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHatWizard, faUpload } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const ChooseCertificateAction: React.FC<ChooseCertificateActionProps> = ({ setModalState, isOpen, close }) => {
  const { t } = useTranslation('addCertificatePanel', { keyPrefix: 'choose' });

  const cards: InfoBoxProps[] = [
    {
      subtitle: t('upload'),
      children: <FontAwesomeIcon icon={faUpload} />,
      onClick: () => setModalState('upload'),
    },
    {
      subtitle: t('generate'),
      children: <FontAwesomeIcon icon={faHatWizard} />,
      onClick: () => setModalState('generate'),
    },
  ];

  return (
    <TaskPanel title={t('title')} isVisible={isOpen} onCancel={close}>
      <InfoBoxContainer>
        {cards.map((c, key) => (
          <InfoBox key={key} {...c} />
        ))}
      </InfoBoxContainer>
    </TaskPanel>
  );
};

export default ChooseCertificateAction;
